import { UserAgentHelper } from './UserAgentHelper';

class WindowHelper {
  /*
    Some very old browsers don't support calling scrollTo
    with only one parameter. That's why this case is handled here.
  */
  static scrollTo(params) {
    // Internet Explorer 11 and below don't fail when invalid parameters are passed.
    // We need to check for it and use the two param version.
    if (UserAgentHelper.isIE11OrBelow()) {
      window.scrollTo(params.left, params.top);
      return;
    }
    // Attempt to call scrollTo with params
    try {
      window.scrollTo(params);
    } catch (error) {
      // If it failed, use the other way of calling it
      window.scrollTo(params.left, params.top);
    }
  }

  static printEnabled() {
    return typeof window.print === 'function';
  }

  static print() {
    if (WindowHelper.printEnabled()) {
      window.print();
    }
  }
}

export { WindowHelper };



// WEBPACK FOOTER //
// ./src/helpers/WindowHelper.js